<div class="weekly-hours-section" [class.weekly-hours-section--compact]="readonly">
  <div class="flex mb-5 gap-2" *ngIf="!readonly">
    <i class="pi pi-arrow-right-arrow-left weekly-icon text-2xl"></i>
    <div>
      <div class="font-bold text-3xl text-gray-800">{{ 'Key.InterviewWeeklyHoursTitle' | translate }}</div>
      <div class="text-gray-700 mt-1">{{ 'Key.InterviewWeeklyHoursSubtitle' | translate }}</div>
    </div>
  </div>

  <div class="days-list" *ngIf="availabilityRule">
    <div class="day-row" *ngFor="let day of dayDefs">

      <div class="day-badge" [class.day-badge--unavailable]="isUnavailable(day.dayOfWeek)">
        {{ day.label }}
      </div>

      <div class="day-content flex flex-column gap-3">

        <ng-container *ngIf="isUnavailable(day.dayOfWeek); else availableTemplate">
          <div class="unavailable-row">
            <span class="text-xl">{{ 'Key.InterviewUnavailable' | translate }}</span>
            <button class="icon-btn" type="button" *ngIf="!readonly" (click)="addSlot(day.dayOfWeek)">
              <i class="pi pi-plus-circle mr-0"></i>
            </button>
          </div>
        </ng-container>

        <ng-template #availableTemplate>
          <ng-container *ngFor="let slot of getActiveSlots(day.dayOfWeek); let i = index">
            <div
              class="time-range-row"
              [class.time-range-row--overlap]="!readonly && hasOverlap(slot)"
            >
              <!-- Start time (readonly) -->
              <span *ngIf="readonly" class="time-readonly">{{ normalizeTime(slot.startTime) }}</span>

              <!-- Start time (editable) -->
              <div class="time-input-wrapper" *ngIf="!readonly">
                <button
                  class="time-input"
                  type="button"
                  (click)="toggleDropdown($event, slotKey(slot) + '-start')"
                >
                  {{ normalizeTime(slot.startTime) }}
                </button>
                <div
                  class="time-dropdown"
                  *ngIf="isOpen(slotKey(slot) + '-start')"
                  (click)="$event.stopPropagation()"
                >
                  <div
                    class="time-option"
                    *ngFor="let t of timeOptions"
                    [class.selected]="t === normalizeTime(slot.startTime)"
                    (click)="setTime(slot, 'start', t)"
                  >
                    {{ t }}
                  </div>
                </div>
              </div>

              <div class="dash">-</div>

              <!-- End time (readonly) -->
              <span *ngIf="readonly" class="time-readonly">{{ normalizeTime(slot.endTime) }}</span>

              <!-- End time (editable) — only shows times after startTime -->
              <div class="time-input-wrapper" *ngIf="!readonly">
                <button
                  class="time-input"
                  type="button"
                  (click)="toggleDropdown($event, slotKey(slot) + '-end')"
                >
                  {{ normalizeTime(slot.endTime) }}
                </button>
                <div
                  class="time-dropdown"
                  *ngIf="isOpen(slotKey(slot) + '-end')"
                  (click)="$event.stopPropagation()"
                >
                  <div
                    class="time-option"
                    *ngFor="let t of endTimeOptions(slot)"
                    [class.selected]="t === normalizeTime(slot.endTime)"
                    (click)="setTime(slot, 'end', t)"
                  >
                    {{ t }}
                  </div>
                </div>
              </div>

              <!-- Remove -->
              <button class="icon-btn" type="button" *ngIf="!readonly" (click)="removeSlot(slot)">
                <i class="pi pi-times mr-0"></i>
              </button>

              <!-- Add new slot (only on first row per day) -->
              <button
                class="icon-btn"
                type="button"
                *ngIf="!readonly && i === 0"
                (click)="addSlot(day.dayOfWeek)"
              >
                <i class="pi pi-plus-circle mr-0"></i>
              </button>

            </div>

            <!-- Overlap warning per slot -->
            <div class="overlap-warning" *ngIf="!readonly && hasOverlap(slot)">
              <i class="pi pi-exclamation-triangle"></i>
              {{ 'Key.InterviewSlotOverlapWarning' | translate }}
            </div>
          </ng-container>
        </ng-template>

        <div
          class="slot-limit-warning"
          *ngIf="slotLimitWarningDay === day.dayOfWeek"
        >
          <i class="pi pi-exclamation-triangle"></i>
          {{ 'Key.InterviewSlotLimitReached' | translate:{ count: MAX_SLOTS } }}
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="timezone-row" *ngIf="!readonly">
    <button class="timezone-btn" type="button" (click)="onTimezoneClick()">
      <span>{{ timezone }}</span>
      <i class="pi pi-chevron-down"></i>
    </button>
  </div> -->
</div>
